import {
  getString,
  getOptionalString,
} from "@surya-digital/leo-ts-types";


export namespace OptOutReason {
  export interface NotInterestedDTO {
    case: string;
  }
  
  export class NotInterested {
    readonly isOptOutReasonNotInterested: boolean = true;
  
  
  
  
  
    toDTO(): NotInterestedDTO {
      const dto: NotInterestedDTO = {
        case: "NOT_INTERESTED",
      };
      return dto;
    }
    }
  
  NotInterested.prototype.toString = function toString(): string {
    return `OptOutReason.NOT_INTERESTED()`;
  };
  
  export interface NotRightPersonDTO {
    case: string;
  }
  
  export class NotRightPerson {
    readonly isOptOutReasonNotRightPerson: boolean = true;
  
  
  
  
  
    toDTO(): NotRightPersonDTO {
      const dto: NotRightPersonDTO = {
        case: "NOT_RIGHT_PERSON",
      };
      return dto;
    }
    }
  
  NotRightPerson.prototype.toString = function toString(): string {
    return `OptOutReason.NOT_RIGHT_PERSON()`;
  };
  
  export interface TooFrequentDTO {
    case: string;
  }
  
  export class TooFrequent {
    readonly isOptOutReasonTooFrequent: boolean = true;
  
  
  
  
  
    toDTO(): TooFrequentDTO {
      const dto: TooFrequentDTO = {
        case: "TOO_FREQUENT",
      };
      return dto;
    }
    }
  
  TooFrequent.prototype.toString = function toString(): string {
    return `OptOutReason.TOO_FREQUENT()`;
  };
  
  export interface EmailsNotCorrectlyRenderedDTO {
    case: string;
  }
  
  export class EmailsNotCorrectlyRendered {
    readonly isOptOutReasonEmailsNotCorrectlyRendered: boolean = true;
  
  
  
  
  
    toDTO(): EmailsNotCorrectlyRenderedDTO {
      const dto: EmailsNotCorrectlyRenderedDTO = {
        case: "EMAILS_NOT_CORRECTLY_RENDERED",
      };
      return dto;
    }
    }
  
  EmailsNotCorrectlyRendered.prototype.toString = function toString(): string {
    return `OptOutReason.EMAILS_NOT_CORRECTLY_RENDERED()`;
  };
  
  export interface PrivacyConcernsDTO {
    case: string;
  }
  
  export class PrivacyConcerns {
    readonly isOptOutReasonPrivacyConcerns: boolean = true;
  
  
  
  
  
    toDTO(): PrivacyConcernsDTO {
      const dto: PrivacyConcernsDTO = {
        case: "PRIVACY_CONCERNS",
      };
      return dto;
    }
    }
  
  PrivacyConcerns.prototype.toString = function toString(): string {
    return `OptOutReason.PRIVACY_CONCERNS()`;
  };
  
  export interface OtherDTO {
    case: string;
    description?: string | null;
  }
  
  export class Other {
    readonly isOptOutReasonOther: boolean = true;
  
    readonly description: string | null;
  
  
    constructor(
    description: string | null = null
    ) {
      if ( description !== undefined && description !== null) {
        Other.validateDescription(description);
      }
      this.description = description;
    }
  
    static fromDTO(dto: OtherDTO): Other {
      const description = getOptionalString(dto, "description", InvalidOptOutReasonOtherDescriptionError);
      return new Other(
        description
      );
    }
  
    toDTO(): OtherDTO {
      const dto: OtherDTO = {
        case: "OTHER",
      };
      if (this.description !== undefined && this.description !== null){
        dto.description = this.description;
      }
      return dto;
    }
    private static validateDescription = (description: string): void => {
      if(description.trim().length === 0) {
        throw new InvalidOptOutReasonOtherDescriptionNonEmptyError(
          `Attribute description cannot be an empty string.`
        );
      }
    }
    
  }
  
  Other.prototype.toString = function toString(): string {
    return `OptOutReason.OTHER(description='${this.description}')`;
  };
  

  export type OptOutReason = NotInterested | NotRightPerson | TooFrequent | EmailsNotCorrectlyRendered | PrivacyConcerns | Other;

  export type OptOutReasonDTO = NotInterestedDTO | NotRightPersonDTO | TooFrequentDTO | EmailsNotCorrectlyRenderedDTO | PrivacyConcernsDTO | OtherDTO;

  export const fromDTO = (dto: OptOutReasonDTO): OptOutReason => {
    switch (dto.case) {
      case "NOT_INTERESTED":
          return new NotInterested();
      case "NOT_RIGHT_PERSON":
          return new NotRightPerson();
      case "TOO_FREQUENT":
          return new TooFrequent();
      case "EMAILS_NOT_CORRECTLY_RENDERED":
          return new EmailsNotCorrectlyRendered();
      case "PRIVACY_CONCERNS":
          return new PrivacyConcerns();
      case "OTHER":
          return Other.fromDTO(dto as OtherDTO);
      default:
        throw new InvalidOptOutReasonError(
            `Case ${dto.case} is not valid case of OptOutReason.`
        );
    }
  };
}

export class InvalidOptOutReasonError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidOptOutReasonError";
  }
}
export class InvalidOptOutReasonNotInterestedError extends InvalidOptOutReasonError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidOptOutReasonNotInterestedError";
  }
}

export class InvalidOptOutReasonNotRightPersonError extends InvalidOptOutReasonError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidOptOutReasonNotRightPersonError";
  }
}

export class InvalidOptOutReasonTooFrequentError extends InvalidOptOutReasonError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidOptOutReasonTooFrequentError";
  }
}

export class InvalidOptOutReasonEmailsNotCorrectlyRenderedError extends InvalidOptOutReasonError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidOptOutReasonEmailsNotCorrectlyRenderedError";
  }
}

export class InvalidOptOutReasonPrivacyConcernsError extends InvalidOptOutReasonError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidOptOutReasonPrivacyConcernsError";
  }
}

export class InvalidOptOutReasonOtherError extends InvalidOptOutReasonError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidOptOutReasonOtherError";
  }
}

export class InvalidOptOutReasonOtherDescriptionError extends InvalidOptOutReasonOtherError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidOptOutReasonOtherDescriptionError";
  }
}

export class InvalidOptOutReasonOtherDescriptionNonEmptyError extends InvalidOptOutReasonOtherDescriptionError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidOptOutReasonOtherDescriptionNonEmptyError";
  }
}
